import { Injectable, Inject } from '@angular/core';
import { FilterTNTOperatorViewModel, TImportadorItemResultsViewModel, TcTNTPaisViewModel } from './buscadoroperador.types';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';






@Injectable()
export class BuscadorOperadorService {

  
    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {


    }

    getTNTOperatorsByFilter(params: HttpParams): Observable<TImportadorItemResultsViewModel> {
        return this.http
            .get<TImportadorItemResultsViewModel>(this.baseUrl + 'api/importacion/solicitud/importador/TRACESPagedByFilter', { params: params })
            .pipe();
    }

    getPaisesOperatorsUE(): Observable<TcTNTPaisViewModel[]> {
        return this.http
            .get<TcTNTPaisViewModel[]>(this.baseUrl + 'api/core/global/paises/TRACESUE').pipe();
    }

    getPaisesOperatorsAllUE(): Observable<TcTNTPaisViewModel[]> {
        return this.http
            .get<TcTNTPaisViewModel[]>(this.baseUrl + 'api/core/global/paises/TRACESALLUE').pipe();
    }
}
